"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const richtext = require("@prismicio/richtext");
const asText = (richTextField, separator) => {
  if (richTextField) {
    return richtext.asText(richTextField, separator);
  } else {
    return null;
  }
};
exports.asText = asText;
//# sourceMappingURL=asText.cjs.map
